var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-file-input',{attrs:{"label":"Datei wählen"},on:{"change":function($event){_vm.file = $event}}}),_c('v-btn',{attrs:{"color":"primary","large":"","rounded":""},on:{"click":_vm.upload}},[_vm._v("Importieren")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }